import { render, staticRenderFns } from "./PotentialPolicyTable.vue?vue&type=template&id=7831aa2f&scoped=true&"
import script from "./PotentialPolicyTable.vue?vue&type=script&lang=js&"
export * from "./PotentialPolicyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831aa2f",
  null
  
)

export default component.exports